<script lang="ts">
    import { Trash2, Archive } from 'lucide-svelte';

    type Props = {
        variant: 'delete' | 'archive';
        onLeadDrop: (leadId: string) => void;
    };

    let { variant, onLeadDrop }: Props = $props();

    let isDragOver = $state(false);

    function handleDragOver(event: DragEvent) {
        event.preventDefault();
        if (!event.dataTransfer) return;
        event.dataTransfer.dropEffect = 'move';
        isDragOver = true;
    }

    function handleDragLeave() {
        isDragOver = false;
    }

    function handleDrop(event: DragEvent) {
        event.preventDefault();
        isDragOver = false;
        const leadId = event.dataTransfer?.getData('leadId');
        if (leadId) onLeadDrop(leadId);
    }

    const config = $derived(
        variant === 'delete'
            ? { label: 'Delete lead drop zone', text: 'Drop here to delete', statusVar: '--status-closed-lost' }
            : { label: 'Archive lead drop zone', text: 'Drop here to archive', statusVar: '--status-archived' },
    );
</script>

<div
    class="drop-zone"
    class:drag-over={isDragOver}
    style="--zone-status: var({config.statusVar})"
    ondragover={handleDragOver}
    ondragleave={handleDragLeave}
    ondrop={handleDrop}
    role="region"
    aria-label={config.label}
>
    <div class="drop-zone-header">
        {#if variant === 'delete'}
            <Trash2 size={32} strokeWidth={1.5} />
        {:else}
            <Archive size={32} strokeWidth={1.5} />
        {/if}
    </div>
    <div class="drop-zone-content">
        <p class="drop-zone-text">{config.text}</p>
    </div>
</div>

<style lang="scss">
    .drop-zone {
        display: flex;
        flex-direction: column;
        background: hsl(var(--zone-status) / 0.15);
        border: 2px dashed hsl(var(--zone-status) / 0.4);
        border-radius: 8px;
        min-width: 120px;
        transition: all 200ms;

        &.drag-over {
            background: hsl(var(--zone-status) / 0.3);
            border-color: hsl(var(--zone-status) / 0.7);
            border-style: solid;
        }
    }

    .drop-zone-header {
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 1rem;
        border-bottom: 1px solid hsl(var(--zone-status) / 0.35);
        background: hsl(var(--zone-status) / 0.25);
        color: hsl(var(--zone-status) / 0.8);
    }

    .drop-zone-content {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 1rem;
    }

    .drop-zone-text {
        font-size: 0.75rem;
        font-weight: 600;
        color: hsl(var(--zone-status) / 0.9);
        text-align: center;
        margin: 0;
        text-transform: uppercase;
        letter-spacing: 0.05em;
    }
</style>